import { render } from "./LegacyDetailPage.vue?vue&type=template&id=0a6c2e6e&scoped=true"
import script from "./LegacyDetailPage.vue?vue&type=script&lang=js"
export * from "./LegacyDetailPage.vue?vue&type=script&lang=js"

import "./LegacyDetailPage.vue?vue&type=style&index=0&id=0a6c2e6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6c2e6e"]])

export default __exports__